// extracted by mini-css-extract-plugin
module.exports = {"sections":"InvoiceGenerator_sections__3e9K7","footer":"InvoiceGenerator_footer__160Ld","downloadBtn":"InvoiceGenerator_downloadBtn__3ZvwN"};